<template>
  <div class="section col_w_3" id="section5">
    <div class="section_wrap">
      <h6 class="--blue70 mb20">
        {{ $t('cookies.basic.myPageTitle') }}
      </h6>
      <p class="option_desc">
        {{$t('cookies.detail.main.title')}}
      </p>
      <CookieSettingButton
        @cookieSetting="cookieSetting"
      />
      <DetailSetting
          v-if="detailOpen"
          @onAccept="handleAccept"
          @onClose="handleClose"
      />
    </div>
  </div>
</template>
<script>
import method from '../../../../modal/cookies/method';

export default {
  name: 'CookieSetting',
  components: {
    CookieSettingButton: () => import('./cookieSettingButton'),
    DetailSetting: () => import('../../../../modal/cookies/detailSetting'),
  },
  props: [],
  data: () => {
    return {
      detailOpen: false,
    }
  },
  methods: {
    ...method,
    cookieSetting() {
      this.detailOpen = true;
    },
    handleAccept(performanceCookies, functionalCookies) {
      this.accept(performanceCookies, functionalCookies);
      this.detailOpen = false;
      // TODO: 알림 on/off 원활하지 않음(임시)
      this?.$modal?.show('common-alert-modal', {
        messageType: 'short',
        message: 'cookies.basic.refresh',
        function: () => {
          location.reload();
        }
      });
    },
    handleClose() {
      this.detailOpen = false;
    },
  },
  computed: {}
}
</script>
<style lang="scss">
    .option_container {
        margin-bottom: 30px;

        .option_title {
            margin-bottom: 20px;
        }

        ul {
            li {
                width: 200px;
            }
        }
    }
</style>